import { createSlice } from '@reduxjs/toolkit';
import type { PartnerIntegrationState } from 'src/types/partner-integration';
import reducers from 'src/redux/partner-integration/reducers';
import extraReducers from 'src/redux/partner-integration/extra-reducers';

export const initialState: PartnerIntegrationState = {
  isLoading: true,
  data: {},
  step: 'login',
};

const partnerIntegration = createSlice({
  name: 'partnerIntegration',
  initialState,
  reducers,
  extraReducers: (builder) => extraReducers(builder),
});

export const {
  updateIntegrationStep,
} = partnerIntegration.actions;

export default partnerIntegration.reducer;
